module.exports = __webpack_public_path__ + "static/img/banner06.290b6c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner06.png
// module id = 5G21
// module chunks = 1